const LOG_PREFIX = '[Article]';

export default {
  LOG_PREFIX,
};
